import data from "../../shared/sharedData";

export default {
  name: "Employer Information",
  sections: [
    {
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select an Employer profile to populate this section (optional)",
          prefill: {
            schema: "employerProfiles",
            type: "employer",
            formName: "9035",
            formSection: "C",
          },
        },
        {
          code: "C.1",
          machine_name: "c1_emp_name",
          widget: "text",
          label: "Legal Business Name",
          parse: ["noSpecialChars"],
          validate: [
            "required",
            {
              minLength: 2,
              message:
                "Legal Business Name must contain at least 5 characters.",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the full legal name of the business, person, association, firm, corporation, or organization, i.e., the employer filing this application. The employer’s full legal name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).`,
        },
        {
          code: "C.2",
          machine_name: "c2_emp_dba",
          widget: "text",
          label: "Trade Name / Doing Business As (DBA), if applicable",
          validate: [
            {
              minLength: 5,
              message: "Trade Name/DBA must contain at least 5 characters.",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the full trade name or “Doing Business As” (DBA) name, if applicable, of the business, person, association, firm, corporation, or organization, i.e., the employer filing this application.`,
        },
        {
          code: "C.12",
          machine_name: "c12_emp_fein",
          widget: "text",
          label:
            "<span>Federal Employer Identification Number <i>(FEIN from IRS)</i></span>",
          feinValidation: true,
          validate: [
            "required",
            "fein",
            { minLength: 10 },
            {
              FEINPrefixValidator: "c12_emp_fein",
              needsFieldValues: true,
              message:
                "Please enter a valid 1st 2 digits of the employer's 9 digit Federal Employer Identification number(FEIN).",
            },
          ],
          parse: "fein",
          maxLength: 10,
          tooltip: `Enter the nine-digit Federal Employer Identification Number (FEIN) as assigned by the IRS. Do not enter a social security number. Note: All employers, including private households, MUST obtain an FEIN from the IRS before completing this application. Information on obtaining an FEIN can be found at <a target="_blank" rel="noopener" href="https://www.irs.gov">www.IRS.gov</a>.`,
        },
        {
          code: "C.13",
          machine_name: "c13_emp_naics_description",
          widget: "text",
          label: "NAICS Description",
          //validate: ["required"],
          hidden: true,
        },
        {
          code: "C.13",
          machine_name: "c13_emp_naics",
          widget: "naics",
          label: "NAICS Code",
          field_to_modify: "c13_emp_naics_description",
          validate: ["required"],
          tooltip: `Enter the four to six-digit North American Industry Classification System (NAICS) code that best describes the employer’s business, not the nonimmigrant worker’s job. A listing of NAICS codes can be found at <a target="_blank" rel="noopener" href="http://www.census.gov/epcd/www/naics.html">www.Census.gov</a>.`,
        },
      ],
    },
    {
      fields: [
        {
          code: "C.3",
          machine_name: "c3_emp_address_1",
          widget: "text",
          label: "Address 1",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Address 1 must contain at least 5 characters.",
            },
          ],
          maxLength: 60,
          tooltip:
            "Enter the street address of the employer’s principal place of business.",
        },
        {
          code: "C.4",
          machine_name: "c4_emp_address_2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip: `If additional space is needed for the street address, use this line to complete the employer’s street address.`,
        },
        {
          code: "C.8",
          machine_name: "c8_emp_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          clearSchema: ["c6_emp_state_id", "c9_emp_province"],
          validate: ["required"],
          tooltip: `Enter the country of the employer’s principal place of business. If the city and country are the same, the name must still be entered in both fields. Note: This entry is for a country, not a county.`,
        },
        {
          code: "C.5",
          machine_name: "c5_emp_city",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: `Enter the city of the employer’s principal place of business. If the city and country are the same, the name must still be entered in both fields.`,
          disabled: true,
          disableWhenField: "c8_emp_country_id",
        },
        {
          code: "C.6",
          machine_name: "c6_emp_state_id",
          widget: "select",
          label: "State",
          state: true,
          selection: data.state,
          validate: ["required"],
          disabled: true,
          disableWhenField: "c8_emp_country_id",
          tooltip: `Enter the State of the employer’s principal place of business.`,
          isVisible: {
            when: "c8_emp_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
        },
        {
          code: "C.9",
          machine_name: "c9_emp_province",
          widget: "text",
          label: "Province",
          maxLength: 25,
          validate: [
            {
              isRequired: "c8_emp_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
            {
              minLength: 5,
              message: "Province must contain at least 5 characters.",
            },
          ],
          tooltip: `Enter the employer’s province, if applicable.`,
          isVisible: {
            when: "c8_emp_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "!==",
            hideStyles: true,
          },
        },
        {
          code: "C.7",
          machine_name: "c7_emp_zip",
          widget: "text",
          label: "Postal Code",
          validate: [
            "required",
            {
              postalCountry: "c8_emp_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "c8_emp_country_id",
              },
            },
          ],
          disabled: true,
          disableWhenField: "c8_emp_country_id",
          maxLength: 10,
          tooltip: `Enter the postal (zip) code of the employer’s principal place of business.`,
        },
      ],
    },
    {
      fields: [
        {
          code: "C.10",
          machine_name: "c10_emp_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          tooltip: `Enter the area code and telephone number for the employer’s principal place of business. Include country code, if applicable.`,
        },
        {
          code: "C.11",
          machine_name: "c11_emp_phone_ext",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip: `Enter the extension of the telephone number for the employer’s principal place of business, if applicable.`,
        },
      ],
    },
  ],
};
